export const PRICERS_GET_NEGOTIATED_RATES_STATE_INVALID = 'INVALID';
export const PRICERS_GET_NEGOTIATED_RATES_STATE_PROCESSED = 'PROCESSED';